import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { DataCard } from '@/components/card'
import { FilterableTable } from '@/components/table/base'
import { CheckboxExportSelectedToCsvItem, CheckboxMenu } from '@/components/table/checkbox'
import { TitleSetter } from '@/components/Title'
import { STORE_STATUS } from '@/constants/store'
import { useLicensesStore } from '@/stores/licenses'

import { LICENSES_TABLE_COLUMNS, LICENSES_TABLE_FILTERS } from './licenses.table'
import { augmentLicenseDataWithPeriods, csvHeaders, formatCsvRow } from './licensesDataAugmentation'

const tableId = 'licenses-table'

export const LicensesView = () => {
  const navigate = useNavigate()

  const { data, isFetching, isLoading } = useLicensesStore(
    useShallow((state) => ({
      data: state.data,
      isLoading: state.status === STORE_STATUS.loading,
      isFetching: state.status === STORE_STATUS.fetching
    }))
  )

  const { fetchData, resetState } = useLicensesStore(
    useShallow((state) => ({
      fetchData: state.fetchData,
      resetState: state.resetState
    }))
  )

  useEffect(() => {
    fetchData()
    return resetState
  }, [])

  return (
    <>
      <TitleSetter title="Licenses" />
      <DataCard
        title="Licenses"
        headerPostfixActions={
          <CheckboxMenu tableId={tableId} minimumToOpen={1}>
            <CheckboxExportSelectedToCsvItem
              csvFileName="operators-license-periods"
              csvHeaders={csvHeaders}
              formatCsvRow={formatCsvRow}
              augmentData={augmentLicenseDataWithPeriods}
            />
          </CheckboxMenu>
        }
      >
        <FilterableTable
          data={data}
          tableId={tableId}
          loading={isLoading}
          fetching={isFetching}
          onRowClick={(row) => navigate(`/licenses/${row.property}`)}
          filters={LICENSES_TABLE_FILTERS}
          columns={LICENSES_TABLE_COLUMNS}
          clientSideSortAndPagination
          clientSideFilters
          withCheckboxes
        />
      </DataCard>
    </>
  )
}
